function getUsedProjectAliases () {
  if (!this.projects) return
  return Object.values(this.projects).map(project => project.alias)
}

export default getUsedProjectAliases